export default __webpack_public_path__ + "static/media/mrs.81f3e40b.png";